/** Read value/checked from Polaris web-component change events. */

export function fieldValue(e: Event): string {
  const t = e.currentTarget as HTMLInputElement | null;
  return t?.value ?? "";
}

export function fieldChecked(e: Event): boolean {
  const t = e.currentTarget as HTMLInputElement | null;
  return !!t?.checked;
}
